module.exports = __webpack_public_path__ + "img/3.e06a774c.png";